// Polyfills für IE Support

// import 'material-icons-font/material-icons-font.css' // Ensure you are using css-loader
// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'  // Defaults to weight 400.
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

import VueScrollTo from 'vue-scrollto'
// import VueAnalytics from 'vue-analytics'
// import VueGtag from 'vue-gtag'

import store from '~/store'
import router from '~/router'
import { i18n } from '~/plugins'
import App from '~/components/App'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import Vuetify from 'vuetify'
// import vuetify from '~/plugins/vuetify'

import 'vuetify/dist/vuetify.min.css'
import de from '~/locale/de.ts'
import VueTimeago from 'vue-timeago'
import VueTimers from 'vue-timers'
import TwentyTwenty from 'vue-twentytwenty'
import VueJsonPretty from 'vue-json-pretty'
import vueNl2br from 'vue-nl2br'

import VueLodash from 'vue-lodash'

import orderBy from 'lodash/orderBy'
// import find from 'lodash/find'

import '~/components'

Vue.config.productionTip = false
Vue.component('nl2br', vueNl2br)
Vue.component('VueJsonPretty', VueJsonPretty)

Vue.use(TwentyTwenty)
Vue.use(VueTimers)
Vue.use(VeeValidate)
Vue.use(Vuetify, {
  lang: {
    locales: { de },
    current: 'de'
  },
  icons: {
    iconfont: 'md'
  },
  theme: {
    primary: '#191e39',
    secondary: '#20619c',
    accent: '#e40945',
    error: '#b71c1c'
  }
})
Vue.use(VueScrollTo, {
  container: '#scrolltainer',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'de', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    de: require('date-fns/locale/de')
  }
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCe2zH-p6qUU4FDJpHz7hDOYqCkXv8Qj78',
    libraries: 'places'
  }
})

// Vue.use(VueGtag, {
//   config: { id: 'UA-119252266-1',
//     params: {
//       'client_storage': 'none',
//       'anonymize_ip': true
//     }
//   }
// }, router)

Vue.use(require('vue-social-sharing'))

Vue.use(VueLodash, { name: 'customlo', lodash: orderBy, find })

new Vue({
  el: '#app',
  i18n,
  store,
  render: (h) => h(App),
  axios,
  router,
  ...App
})

window.axios = axios
